module.exports = __webpack_public_path__ + "img/honor.9b2d92a7.png";